export enum ProSkillAssureAnswerCodeSubmitType {
    SUBMIT = "SUBMIT", RUN = "RUN"
}
